import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_392: DocMigration = {
  maxSchemaVersion: "0.0.392",
  description: "Roof truncation refactoring",
  apply(json: any) {
    const { roofs } = json;

    // roof instances
    for (const roofId in roofs) {
      const roof = roofs[roofId];

      // migrate existing flags
      const flags: { [id: string]: boolean } = {};

      if (roof.legacyHeelHeightOffsets) {
        flags["LEGACY_HEEL_HEIGHT_OFFSETS"] = true;
      }

      if (roof.legacyRoofSlope) {
        flags["LEGACY_SLOPE"] = true;
      }

      delete roof.legacyHeelHeightOffsets;
      delete roof.legacyRoofSlope;

      // add the legacy truncation flag
      flags["LEGACY_TRUNCATION"] = true;

      // add the flags set to the roof
      roofs[roofId] = {
        ...roof,
        flags,
      };
    }

    return json;
  },
};

export default migration_0_0_392;
